import { GenerateId } from "../util";
import GameObject from "./GameObject";

export default class MonoBehavior {

    id: string = GenerateId();
    gameObject: GameObject;

    get engine() { return this.gameObject.engine; }
    get ctx() { return this.engine.ctx; }

    get transform() { return this.gameObject.transform; }

    constructor(gameObject: GameObject) {
        this.gameObject = gameObject;
    }

    Equals(other: MonoBehavior) {
        return this.id === other.id;
    }

    Init() {
        
    }

    Start() {

    }

    Update() {

    }

    LateUpdate() {

    }

    Draw() {

    }

    DrawGizmos() {
        
    }

}